import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class CommentService {
  private setError: (message: string | null) => void

  constructor (setError: (message: string | null) => void) {
    this.setError = setError
  }

  async postComment (type: string, message: string) {
    return axiosInstance
      .post('/comment', {
        type,
        message
      })
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }
}
